import { Col, Container, Row } from 'react-bootstrap'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import service_bg from './../../assets/service_bg.png'
import img1 from './../../assets/Frame_1171275688.png'
import img2 from './../../assets/Frame_171275688.png'
import icon1 from './../../assets/icons8_idea.png'
import icon2 from './../../assets/carbon_task-tools.png'
import icon3 from './../../assets/garden_security-26.png'
import icon4 from './../../assets/fluent_people-community-12-filled.png'

function Advisory() {
  return (
    <div className='wrap-hidden'>
      <div className='pb-5 pt-5'
        style={{
          backgroundImage: `url(${service_bg})`,
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
          backgroundSize: "100% auto",
        }}
      >
        <Container className='mt-5 pt-5 pb-5'>
          <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
            <div className='mt-5 header text-center'><span className="text-brand-secondary">Advisory</span> & Consultancy</div>
            <p className='mt-4 text-justify text-center'><strong>Expert-Led Cyber Guidance for a Cloud-Driven World</strong></p>
            <p className='mt-4 stext-justify text-center'>In today’s complex digital landscape, navigating cybersecurity isn’t optional it’s business critical.</p>
            <p className='text-justify text-center'>Siberwander offers tailored, expert led advisory and consulting services to help organizations build a secure, scalable digital foundation. Whether you're launching your cloud journey or strengthening your cyber maturity, we’re here to help you move forward, simply, securely, and strategically.</p>
          </AnimationOnScroll>

          <div className='mt-5 card-shadow'>
            <div className='bg-main-secondary-light pt-5 pb-5 ps-2 pe-2'>
              <div className='header text-center'>What <span className="text-brand-secondary">We Offer</span></div>
            </div>
            <div className='p-5 category ps-5 pe-5'>
              <Row className='align-items-center'>
                <Col xs={12} md={5} className='mb-3'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <h4><strong>Prepare & <span className="text-brand-secondary">Protect</span></strong></h4>
                    <div className='mt-3'><strong>Architecting Resilience Before Risk Becomes Reality.</strong></div>
                    <p className='text-justify'>We go beyond conventional assessments helping you anticipate threats, align security with business objectives, and embed cyber resilience from the ground up.</p>
                    <br/>
                    <p className='text-justify'>From cloud posture analysis to critical infrastructure reviews, we co-create a strategic security framework tailored to your operations, data sensitivity, and regulatory needs. So you’re not just protected, but prepared to scale securely.</p>
                    <div className='mt-3'><strong>Includes:</strong></div>
                    <ul>
                      <li>Vulnerability Assessment and Penetration Testing</li>
                      <li>Business Continuity Planning and Disaster Recovery Strategy</li>
                      <li>Information Security Risk Management Advisory</li>
                      <li>Cybersecurity Posture and Maturity Assessment</li>
                      <li>Operational Technology Penetration Testing</li>
                      <li>Cyber Security Gap Analysis and Roadmap Development</li>
                      <li>Secure Software Development Life Cycle</li>
                      <li>SWIFT & RENTAS Security Assessment</li>
                      <li>RMiT Compliance Advisor</li>
                      <li>Cloud Security Service</li>
                      <li>ISO 27001 Advisory</li>
                      <li>Data Governance</li>
                      <li>ScopeX</li>
                    </ul>
                  </AnimationOnScroll>
                </Col>
                <Col xs={12} md={1}/>
                <Col xs={12} md={6} className='mb-3 text-center'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <img src={img1} style={{width:'100%'}} alt=""/>
                  </AnimationOnScroll>
                </Col>
              </Row>
              <Row className='align-items-center mt-2'>
                <Col xs={12} md={6} className='mb-3 text-center'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <img src={img2} style={{width:'100%'}} alt=""/>
                  </AnimationOnScroll>
                </Col>
                <Col xs={12} md={1}/>
                <Col xs={12} md={5} className='mb-3'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <h4><strong>Remediate & <span className="text-brand-secondary">Correct</span></strong></h4>
                    <div className='mt-3'><strong>Turn Insight Into Actionable Resilience.</strong></div>
                    <p className='text-justify'>Once vulnerabilities are surfaced, we don’t stop at analysis we operationalize security improvements through structured enablement, capability uplift, and human layer reinforcement.</p>
                    <br/>
                    <p className='text-justify'>From precision driven simulations to executive-grade cybersecurity training, we help transform your teams into proactive defense assets ready to neutralize threats before they escalate.</p>
                    <div className='mt-3'><strong>Includes</strong></div>
                    <ul>
                      <li>Enterprise Security Professional Certification & Training</li>
                      <li>Cybersecurity Awareness Training</li>
                      <li>Cybersecurity Skill Trainin</li>
                      <li>Phishing Simulation</li>
                    </ul>
                  </AnimationOnScroll>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </div>
      <Container className='pb-5'>
        <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
          <div className='header text-center'>Why Choose  <span className="text-brand-secondary">Siberwander?</span></div>
          <p className='mt-4 text-justify text-center'><strong>Built for Practitioners. Designed for Progress. Powered by Community.</strong></p>
        </AnimationOnScroll>
        <div className='card-shadow mt-4 bg-main-secondary-light'>
          <div className='category ps-5 pe-5 pt-4'>
            <Row>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon1} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Effortless, Impactful Learning</strong></div>
                    <p className='text-center mt-2'>We use simplified, modern formats no boring theory dumps. Just clear, engaging content that sticks.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={100} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon2} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Real Tools. Real Scenarios. Real Readiness.</strong></div>
                    <p className='text-center mt-2'>Train with the same use cases and toolsets used by professionals in real-world environments.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={150} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon3} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Agentless-First Security Perspective</strong></div>
                    <p className='text-center mt-2'>Get ahead with a modern, frictionless approach to cloud security built for scale, speed, and visibility.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon4} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Community-Driven Ecosystem</strong></div>
                    <p className='text-center mt-2'>Grow with a network of learners, mentors, and practitioners because cybersecurity is stronger when shared.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Advisory